import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    
    useEffect(() => {
        const t = setTimeout(() => {
            if (hash) {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                    return;
                }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 1000);

        return () => clearTimeout(t);
    }, [pathname]);

    return null;
}

export default ScrollToTop;
